import React, { FC } from "react";
import { theme } from "@ovou-inc/ovou-ui";
import { BiPlus } from "react-icons/bi";

import { IContact } from "../types/Contact";
import { TagColorIndicator } from "./TagColorIndicator";
import { ButtonOutlined, Flex, Text } from "../../../components";

interface ITableTagsColumnProps {
  contact: IContact;
  onManageContactTags: (contact: IContact) => void;
}

export const TableTagsColumn: FC<ITableTagsColumnProps> = ({
  contact,
  onManageContactTags,
}) => {
  const tags = contact.tags ?? [];
  const hasTags = tags.length > 0;

  return (
    <Flex>
      {hasTags && (
        <Flex alignItems="center" flexWrap="wrap" gap={1} marginRight={2}>
          {tags.map(tag => (
            <TagColorIndicator key={tag.id} color={tag.color} />
          ))}
        </Flex>
      )}

      <ButtonOutlined
        padding={2}
        onClick={e => {
          e.stopPropagation();
          onManageContactTags(contact);
        }}
        _hover={{ border: "none" }}
      >
        <BiPlus
          color={theme.palette.brand.primary.black}
          style={{ marginRight: 0 }}
          size={16}
        />
        {!hasTags && (
          <Text
            fontWeight="semibold"
            fontSize={14}
            color={theme.palette.brand.primary.black}
            marginLeft={1}
          >
            Add Tags
          </Text>
        )}
      </ButtonOutlined>
    </Flex>
  );
};
